export default "__VITE_ASSET__c70f5e79__"